/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_WinnerInputs */



/**
* | output |
* | --- |
* | "Winner Only" |
*
* @param {Og_Cfg_WinnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_winner = /** @type {((inputs?: Og_Cfg_WinnerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_WinnerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vainqueur uniquement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo el ganador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas o vencedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo il vincitore")
	return /** @type {LocalizedString} */ ("Winner Only")
});